import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DefaultTopLevelGroup, Status } from "../../../../common/constants";
import { listQuickAlertsUrl } from "../../../../config";
import { RootState } from "../../../../store";
import api from "../../../../api";

export const GET_QUICKALERTS = "getQuickAlerts";

interface ListQuickAlertsState {
  quickalerts: any | null;
  groupOptions: Array<{ displayName: string }>;
  status: any;
  error: string | null;
}

const initialState: ListQuickAlertsState = {
  quickalerts: null,
  groupOptions: [],
  status: Status.IDLE,
  error: null,
};

interface FetchParams {
  page?: number;
  limit?: number;
  search?: string;
  severity?: string;
  group?: string;
}


export const fetchQuickAlertsData = createAsyncThunk(
  GET_QUICKALERTS,
  async (params?: FetchParams) => {
    let url = `${listQuickAlertsUrl}?orgId=${DefaultTopLevelGroup.ID}`;

    if (params?.page && params?.limit) {
      url += `&page=${params.page}&limit=${params.limit}`;
    }

    if (params?.search) {
      url += `&search=${encodeURIComponent(params.search)}`;
    }

    if (params?.severity) {
      url += `&severity=${params.severity}`;
    }

    if (params?.group) {
      url += `&group=${params.group}`;
    }

    const response = await api.get(url);
    return response.data;
  }
);


const listQuickAlertsSlice = createSlice({
  name: GET_QUICKALERTS,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuickAlertsData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(fetchQuickAlertsData.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.quickalerts = action.payload;
        state.groupOptions = action.payload?.groupOptions || [];
      })
      .addCase(fetchQuickAlertsData.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message || null;
      });
  },
});

export const selector = (state: RootState) => state.listQuickAlertsApi;

export const reducer = listQuickAlertsSlice.reducer;
